import { IFeedbackState, TReduxActions, EFeedbackScreen } from '../../types/redux';
import { actionTypes } from '../../constants/actionTypes';

export const defaultState: IFeedbackState = {
  topPosition: 0,
  height: 0,
  screen: EFeedbackScreen.Form,
  isLoading: false,
  isSendError: false,
  isVisibleForm: true,
};

export function feedbackReducer(state: IFeedbackState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case actionTypes.SET_DIMENSIONS_FEEDBACK:
      return {
        ...state,
        topPosition: action.payload.top,
        height: action.payload.height,
      };

    case actionTypes.TOGGLE_LOAD_FEEDBACK:
      return {
        ...state,
        isLoading: action.payload,
      };

    case actionTypes.TOGGLE_SCREEN_FEEDBACK:
      return {
        ...state,
        screen: action.payload,
      };

    case actionTypes.SET_SEND_ERROR_FEEDBACK:
      return {
        ...state,
        isSendError: true,
        isLoading: false,
      };

    default:
      return state;
  }
}
